import { render, staticRenderFns } from "./DuplicateControl.vue?vue&type=template&id=1cb5b9da&"
import script from "./DuplicateControl.vue?vue&type=script&lang=js&"
export * from "./DuplicateControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports